import { getApiUrl } from '@/lib/api-url'
import { fetchWithAuth } from '@/lib/auth'

export interface NotificationDto {
  notificationId: string
  userId: string
  title: string
  messageBody: string
  createdAt: string
  readAt: string | null
  isRead: boolean
  truncatedPreview: string
}

export interface RecentNotificationsResponse {
  items: NotificationDto[]
  unreadCount: number
}

export interface PaginatedNotificationsResponse {
  items: NotificationDto[]
  total: number
  page: number
  pageSize: number
  unreadCount: number
}

export async function fetchUnreadCount(): Promise<{ unreadCount: number }> {
  const res = await fetchWithAuth(`${getApiUrl()}/notifications/unread-count`)
  if (!res.ok) {
    const err = await res.json().catch(() => ({}))
    throw new Error((err as { message?: string }).message || 'خطا در دریافت تعداد اعلان‌ها')
  }
  return res.json()
}

export async function fetchRecentNotifications(limit = 5): Promise<RecentNotificationsResponse> {
  const res = await fetchWithAuth(`${getApiUrl()}/notifications?limit=${limit}`)
  if (!res.ok) {
    const err = await res.json().catch(() => ({}))
    throw new Error((err as { message?: string }).message || 'خطا در دریافت اعلان‌ها')
  }
  return res.json()
}

export async function fetchNotificationsPage(
  page: number,
  pageSize = 25,
  unreadOnly = false
): Promise<PaginatedNotificationsResponse> {
  const params = new URLSearchParams({
    page: String(page),
    size: String(pageSize),
  })
  if (unreadOnly) {
    params.set('unreadOnly', 'true')
  }
  const res = await fetchWithAuth(`${getApiUrl()}/notifications?${params.toString()}`)
  if (!res.ok) {
    const err = await res.json().catch(() => ({}))
    throw new Error((err as { message?: string }).message || 'خطا در دریافت فهرست اعلان‌ها')
  }
  return res.json()
}

export async function fetchUnreadNotificationsPage(
  page: number,
  pageSize = 25
): Promise<PaginatedNotificationsResponse> {
  const params = new URLSearchParams({
    page: String(page),
    size: String(pageSize),
  })
  const res = await fetchWithAuth(`${getApiUrl()}/notifications/unread?${params.toString()}`)
  if (!res.ok) {
    const err = await res.json().catch(() => ({}))
    throw new Error((err as { message?: string }).message || 'خطا در دریافت اعلان‌های خوانده‌نشده')
  }
  return res.json()
}

export async function fetchNotificationById(id: string): Promise<NotificationDto> {
  const res = await fetchWithAuth(`${getApiUrl()}/notifications/${id}`)
  if (!res.ok) {
    const err = await res.json().catch(() => ({}))
    throw new Error((err as { message?: string }).message || 'اعلان یافت نشد')
  }
  return res.json()
}

export async function markNotificationRead(notificationId: string): Promise<NotificationDto> {
  const res = await fetchWithAuth(`${getApiUrl()}/notifications/${notificationId}/read`, {
    method: 'PATCH',
  })
  if (!res.ok) {
    const err = await res.json().catch(() => ({}))
    throw new Error((err as { message?: string }).message || 'خطا در ثبت خوانده‌شدن')
  }
  return res.json()
}
